var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        id: "term-of-service-modal",
        title: "Privacy Policy / Terms and Conditions",
        okText: "I read and agree",
        cancelText: "Cancel",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: function ($event) {
          return _vm.$emit("agree")
        },
      },
    },
    [
      _c(
        "a-tabs",
        { attrs: { "default-active-key": _vm.type } },
        [
          _c("a-tab-pane", { key: "pp", attrs: { tab: "Privacy Policy" } }, [
            _c("div", { staticClass: "term-of-service-modal-content" }, [
              _c("h4", [
                _c("b", [
                  _vm._v(
                    "Privacy Policy for Supsis Live Support & Chatbot Systems"
                  ),
                ]),
              ]),
              _vm._v(
                "\n                This Privacy Policy describes how Softcand Yazilim Hizmetleri A.S. (“Softcand,” “we,” “us,” or\n                “our”) collects, uses, and discloses information about users (“you” or “your”) of our web\n                application, Supsis Live Support & Chatbot Systems (“Supsis”). This Privacy Policy applies to\n                information we collect when you use Supsis, whether accessed via our website, mobile applications,\n                or any other platform where the Privacy Policy is posted."
              ),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_c("b", [_vm._v("Information We Collect")])]),
              _vm._v(" "),
              _c("b", [_vm._v("We collect the following information")]),
              _vm._v(":"),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Customer Account Information")]),
              _vm._v(
                ": When creating a Supsis account, we collect the following data:\n                name, surname, phone number, and email address."
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v(" User Information")]),
              _vm._v(
                ": Information provided by users of the application, including name, surname,\n                and email address."
              ),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_c("b", [_vm._v("Data Deletion Process")])]),
              _vm._v(" "),
              _c("b", [
                _vm._v("We follow these procedures for data deletion:"),
              ]),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Automatic Deletion")]),
              _vm._v(
                ": Customer accounts are automatically deleted when closed or after six\n                months of inactivity."
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Direct Request")]),
              _vm._v(
                ": Customers may request deletion of all their data by contacting us\n                directly."
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Website Visitor Data Deletion")]),
              _vm._v(
                ": Website visitors can delete their data directly through the\n                webchat interface, including conversation history, messages, and files."
              ),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_c("b", [_vm._v("How to Contact Us")])]),
              _vm._v(" "),
              _c("b", [
                _vm._v("You can reach us through the following channels"),
              ]),
              _vm._v(":"),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n\n                Email: m@softcand.com WhatsApp: +902162322282 Website: supsis.com or softcand.com Live Support on\n                Website: supsis.com or softcand.com"
              ),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_c("b", [_vm._v("Data Processing and Sharing")])]),
              _vm._v(" "),
              _c("b", [_vm._v("We handle customer data as follows:")]),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("No Third-Party Sharing")]),
              _vm._v(
                ": Supsis does not share customer data with any third-party\n                organizations, companies, or individuals."
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Promotional Emails")]),
              _vm._v(
                ": We may send promotional emails to customers, who can choose to\n                unsubscribe from these newsletters."
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Visitor and Conversation Data")]),
              _vm._v(
                ": We do not share or use customer visitor and conversation\n                information."
              ),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_c("b", [_vm._v("3rd Party Services")])]),
              _vm._v(" "),
              _c("h5", [_c("b", [_vm._v("Google OAuth")])]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Google Calendar")]),
              _vm._v(
                ": Supsis utilizes Google Calendars to enable calendar-related functionalities\n                within the application. Data synchronized from calendars is not shared with anyone and is only\n                visible to the user. When Google OAuth is terminated, all synchronized events from Supsis and Google\n                Calendar are automatically deleted."
              ),
              _c("br"),
              _vm._v(" "),
              _c("b", [_vm._v("Google Account Public Profile")]),
              _vm._v(
                ": Supsis collects name and email information to verify and\n                authenticate users during login. This information is not stored after verification."
              ),
              _c("br"),
              _c("br"),
              _vm._v(" "),
              _c("h4", [_c("b", [_vm._v("Changes to this Privacy Policy")])]),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                "\n                We may update this Privacy Policy from time to time. If we make material changes, we will notify you\n                by posting the updated Privacy Policy on our website or through other communication channels.\n                "
              ),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n                If you have any questions about this Privacy Policy, please contact us at m@softcand.com.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a-tab-pane",
            {
              key: "tac",
              attrs: { tab: "Terms and Conditions", "force-render": "" },
            },
            [
              _c("div", { staticClass: "term-of-service-modal-content" }, [
                _c("br"),
                _vm._v(" "),
                _c("h4", [
                  _vm._v(
                    "Terms of Service for Supsis Live Support & Chatbot Systems"
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n                Last updated 27 June 2023. In effect as of 1 July 2023. Important: These Terms of Service, which\n                include our Privacy Policy, (Terms) form a binding contract between the person (including without\n                limitation any individual, company or other organisation that the person represents) named during\n                the “Sign up” process as the user of the Service (“you”) and Softcand Yazılım Hizmetleri Anonim\n                Şirketi (trading as Supsis or Supsis Live Support or Supsis Live Support and Chatbot Systems) (“us”)\n                and govern your use of our websites located at supsis.com (product landingpage), softcand.com\n                (company webpage) or supsis.live (product app) or beta.supsis.live (product app beta version)\n                (including any subdomains thereof) and any applications and services made available to you by us in\n                connection with those websites (collectively “Service”). For that reason these Terms are important\n                and you should ensure that you read them carefully and contact us with any questions before you use\n                the Service. You can contact us on m@softcand.com. By registering to use or using the Service you\n                agree to be bound by the Terms. If you do not agree to be bound by the Terms, you must not use the\n                Service.\n\n                "
                ),
                _c("br"),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("1 Application of terms")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        These Terms apply to all users of the Service, whether you are using the Service on your own\n                        behalf or on behalf of another individual or organisation. If you are using the Service on\n                        behalf of a company or other organisation with their authorisation, these Terms bind you in\n                        your personal capacity and that company or other organisation.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        We may update or change the Terms at any time at our discretion. If we change the Terms, we\n                        will notify you by alerting you through our web platform and by email. You must agree to be\n                        bound by the updated Terms by clicking your acceptance in the notice presented to you before\n                        continuing to use the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        If you do not agree to the updated Terms, you must not continue to use the Service and\n                        cancel the account with effect from the date you notify us of the cancellation in writing.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        If you are classified as a “consumer” under applicable law, you may have legal rights under\n                        that local law which would prohibit all or parts of some of the limitations and exclusions\n                        set out in these Terms from applying to you, and where prohibited they will not apply to\n                        you. To find out more about those rights, you should contact a local consumer advice\n                        organisation.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("2 The Service")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        We grant you a non-exclusive, worldwide, non-transferable, revocable right to use the\n                        Service in accordance with these Terms.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You may access and use the Service (including any incidental copying that occurs as part of\n                        that use) in accordance with these Terms.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        When you log into the Service and connect a social media account to the Service (Account),\n                        you appoint us as your agent in respect of that Account to conduct actions on your behalf,\n                        at your direction (such as response a direct message on Instagram or another Platform (as\n                        defined below)) in providing the Service to you (Agency).\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        When you connect additional Accounts to the Service, you also appoint us as your agent in\n                        respect of those accounts to undertake the activities within the scope of the Agency.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You warrant that you control each Account and that you are authorised to appoint us as your\n                        agent with authority to undertake the activities within the scope of the Agency on your\n                        behalf for each Account.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You acknowledge and agree that the Service is not affiliated with or authorised by\n                        Instagram, Facebook, Twitter or any other social media service for which we supply the\n                        Service (Platforms) and that any access to each Platform, (including via the Service) is\n                        governed by the applicable Platform’s Terms of Use. For example, your use of any Google\n                        products such as YouTube is governed by the YouTube Terms of Service. For instagram you can\n                        check the terms of service from Instagram Terms of Service. For messenger/facebook you can\n                        check the terms of service from Facebook Terms of Service. You indemnify us and hold us\n                        harmless against any claim by the operator of any Platform that the Service, or your use of\n                        the Service, breaches the terms of use of the Platform.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        The Service contains links to other websites as well as Content (as defined below) added by\n                        people other than us. We do not endorse, sponsor or approve any such user generated Content\n                        or any Content available on any linked website.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        We do not have any obligation to monitor, edit or remove Content uploaded or posted by our\n                        users to the Service and then posted to an Account on any of the Platforms.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You acknowledge and agree that: (1) we retain control over the Service and may alter, amend\n                        or cease the operation of the Service at any time in our sole discretion (we will give you\n                        reasonable notice of any alteration that materially adversely affects the functionality of\n                        the Service); (2) the Service may be unavailable from time to time (including for\n                        maintenance purposes) and, to the extent possible, we will notify you of any scheduled\n                        downtime; and (3) we may refuse to publish Content that you add to the Service that we\n                        consider, acting reasonably, does not comply with section 3 of these Terms.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("3 Your Rights And Obligations")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        You must not add any Content to the Service: (1) unless you hold all necessary rights,\n                        licences and consents to do so; (2) that would cause you or us to breach any law or\n                        regulation or any other legally enforceable rule, code or other obligation; (3) that is or\n                        that we, acting reasonably, consider to be spam, obscene, inappropriate, defamatory,\n                        disparaging, indecent, seditious, offensive, pornographic, threatening, abusive, liable to\n                        incite racial hatred, unlawful, discriminatory, blasphemous, in breach of confidence or in\n                        breach of any privacy law; (4) that would bring us, or the Service, into disrepute; or (5)\n                        that infringes the intellectual property or other rights of any person.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You must not: (1) attempt to duplicate or replicate, or reproduce, modify or prepare\n                        derivative works of, the Service, Content that we publish on or in relation to the Service\n                        or any other material that you do not own or for which you do not have a relevant licence;\n                        (2) distribute viruses or code that is otherwise malicious ; (3) use the Service to publish\n                        information that is misleading or deceptive; (4) access another person’s Account on our\n                        Service without their permission; (5) alter, disable, interfere with or circumvent any\n                        aspect of the Service or test or reverse-engineer the Service in order to find limitations,\n                        vulnerabilities or evade filtering capabilities; or (6) do anything designed to affect\n                        access to or the integrity of the Service.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("4 Payments")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("You acknowledge and agree that")]),
                _vm._v(":\n                "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        we will debit your nominated payment method on the specified billing date (the day that your\n                        trial period ends) each month, year or other billing period (as applicable) for the next\n                        billing period in advance, unless you cancel the Service prior to this date; and\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        if you cancel the Service, you will continue to have access to the Service until your next\n                        billing date, and any refund of any monies paid for the current billing period is at our\n                        discretion (that is, payments are non-refundable, except at our discretion).\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("5 Intellectual Property")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        In these Terms, “Content” includes material in text, audio, graphic, pictorial and video\n                        form, or any combination of material, in any form.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        Nothing in these Terms constitutes a transfer of any intellectual property rights. You\n                        acknowledge and agree that, as between you and us, we own all intellectual property rights\n                        in the Service (that is, we own the rights to the applications we make available to you – we\n                        do not own intellectual property rights to your Content – see below in 5(3)).\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        We acknowledge that as between you and us, you own or have a licence to all intellectual\n                        property rights in the Content that you provide to the Service or otherwise provide to us\n                        for the purpose of providing the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You grant us a perpetual, non-exclusive, royalty-free, irrevocable, worldwide and\n                        transferable right and licence to use, in any way (including by posting to an Account on any\n                        Platform as directed by you): (a) Content that you add to the Service; and (b) profile\n                        content on social media Platforms associated with your Account (including, without\n                        limitation, by reproducing, changing or adapting, and communicating that Content to the\n                        public) for the purposes of providing you with the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        We may sub-licence the licence in paragraph 5(4) to third party service providers who assist\n                        us in providing the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        In some countries in which the Service operates, local law recognises that authors of\n                        Content may have “moral rights” in respect of the Content. Examples of moral rights can\n                        include the right to be attributed as the author of Content, the right to object to false\n                        attribution of the authorship of content and the right to object to derogatory treatment of\n                        Content in some circumstances. We will be unable to provide the Service if authors of\n                        Content assert moral rights that may they have in Content that is published on the Service.\n                        When you post or add Content to the Service, you agree that you will not enforce any moral\n                        rights that you may have in respect of that Content, and if you add any Content in which any\n                        third party has moral rights, you will use your best efforts to ensure that the third party\n                        also gives the same commitment.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "The licence in paragraph 5(4) will survive any termination of these Terms."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You represent and warrant to us that you have all necessary rights to grant the licences and\n                        other commitments set out in this clause 5.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You acknowledge and agree that, in providing the Service, we collect historical Content\n                        from, and other data about, your Accounts and the social media accounts of other customers\n                        of the Service, for the purposes of providing analytics reports and other features such as\n                        our “Instagram Planner”.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("6 Warranties")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(" You represent and warrant to us that")]),
                _vm._v(":\n\n                "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "all Accounts, on any Platform, added to the Service are owned or controlled by you;"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "you will use the Service in accordance with these Terms; and"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "you have the legal capacity and the authority to enter into these Terms."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("7 Liability")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        You are liable for any loss or damage caused if you breach your obligations under these\n                        Terms or you fail to use reasonable care in your use of the Service. Your liability will be\n                        reduced to the extent that we cause or contribute to that loss or damage by our own breach\n                        of these Terms or our own failure to use reasonable care in providing the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You indemnify us for any loss or damage we suffer as a result of your breach of these Terms\n                        (including the warranties you give us under these Terms), or any wilful misconduct, unlawful\n                        acts or negligence in your use or misuse of the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        To the full extent permitted by law, and subject where applicable to clauses 7(5) and 7(6)\n                        of these Terms, we exclude all liability for all claims, expenses, loss, damage and costs\n                        made against or incurred by you directly or indirectly arising out of or in connection with\n                        your use of the Service or your inability to use the Service, including in respect of\n                        economic loss, loss of data, interruption of business or any consequential or incidental\n                        damages.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        To the full extent permitted by law, and subject where applicable to clauses 7(5) and 7(6)\n                        of these Terms, our total liability to you for breach of contract under these Terms, for\n                        tort (including negligence), or for any other cause is limited to an amount equal to the\n                        total aggregate fee paid or payable by you for the Service for the one month period\n                        immediately preceding the day upon which our liability arose.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        To the full extent permitted by law, and subject where applicable to clause 7(6) and 7(7) of\n                        these Terms, we exclude all terms, representations, warranties, conditions, guarantees or\n                        obligations (whether express or implied) other than those expressly set out in these Terms.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        In some jurisdictions, legislation may require that certain warranties, conditions,\n                        guarantees or obligations relating to the Service are implied into these Terms or imposed on\n                        our supply of the Service (“statutory obligations”). Further, the legislation may prohibit,\n                        or render void, other terms that have the effect of excluding, limiting or modifying imposed\n                        terms, or the exercise of rights and remedies, or the recovery of compensation, otherwise\n                        available to you where we breach an imposed term (“statutory prohibition”).\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        If legislation referred to in clause 7(6) applies to these Terms as accepted by you, or to\n                        the Service as provided to you, nothing in these Terms is intended to be, or operates as, a\n                        statutory prohibition. In particular, no part of these Terms is intended to limit our\n                        liability where that part would be a statutory prohibition.\n                    "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("8 Termination")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        These Terms terminate automatically if, for any reason, we cease to operate the Service.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        We may otherwise terminate or suspend your access to the Service immediately, on notice to\n                        you, if in our reasonable opinion, you have breached these Terms in any way.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        You may cancel the Service at any time by notifying us, and you can continue to access the\n                        Service until the end of your current billing period.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "All rights granted to you in these Terms cease upon termination."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("9 General")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                        You must not assign, sublicence or otherwise deal in any other way with any of your rights\n                        under these Terms.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        If a provision of these Terms is invalid or unenforceable, it is to be read down or severed\n                        to the extent necessary without affecting the validity or enforceability of the remaining\n                        provisions.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        Each party must at its own expense do everything reasonably necessary to give full effect to\n                        this Agreement and the events contemplated by it.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(
                      "\n                        These Terms are governed by the laws of Turkey and each party submits to the jurisdiction of\n                        the courts of Turkey\n                    "
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }